import { render } from "./GratioTrend.vue?vue&type=template&id=5ecdd52b&scoped=true"
import script from "./GratioTrend.vue?vue&type=script&lang=js"
export * from "./GratioTrend.vue?vue&type=script&lang=js"

import "./GratioTrend.vue?vue&type=style&index=0&id=5ecdd52b&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecdd52b"]])

export default __exports__